import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import './RequestService.css';
import qrLogo from '../../assets/images/qr-icon.svg';
import { BrowserMultiFormatReader } from '@zxing/library';
import { api, userId, submitRequestService } from '../../Api';

function RequestService() {
  const location = useLocation();
  const { item } = location.state || {};

  const [formData, setFormData] = useState({
    id: item?.ac.id || '',
    nama_ac: item?.ac.nama_ac || '',
    merek_ac: item?.ac.merek_ac || '',
    serial_number: item?.ac.serial_number || '',
    ketinggian_ac: item?.ac.ketinggian_ac || '',
    kapasitas_pk: item?.ac.kapasitas_pk || '',
    message: '',
  });

  const [isScanning, setIsScanning] = useState(false);
  const [scanner, setScanner] = useState(null);
  const [videoElement, setVideoElement] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isManualInput, setIsManualInput] = useState(false); // New state for manual input

  useEffect(() => {
    if (!item || Object.keys(item).length === 0) {
      setIsManualInput(true);
    }
  }, [item]);

 useEffect(() => {
  if (isScanning && videoElement) {
    const codeReader = new BrowserMultiFormatReader();
    setScanner(codeReader);

    codeReader.decodeFromVideoDevice(null, videoElement, (result, err) => {
      if (result) {
        handleQRCodeScan(result.getText());
      } else if (err) {
        // Only log errors that are not NotFoundException
        if (err.name !== 'NotFoundException') {
          // console.error('QR Code Scan Error:', err);
        }
      }
    });
  }

  return () => {
    if (scanner) {
      scanner.reset();
    }
  };
}, [isScanning, videoElement]);


  const startScanner = () => {
    setIsScanning(true);
    setErrorMessage('');
    setIsManualInput(false); // Reset manual input
  };

  const stopScanner = () => {
    if (scanner) {
      scanner.reset();
    }
    setIsScanning(false);
  };

  const handleQRCodeScan = async (qrData) => {
    if (qrData.endsWith('-JID')) {
      try {
        const response = await api.get(`/getac/${qrData}/${userId}`);

        if (response.status === 200) {
          const data = response.data.data;

          if (!data || Object.keys(data).length === 0) {
            setErrorMessage('Data tidak ditemukan.');
            stopScanner();
            return;
          }

          setFormData({
            id: data.id || '',
            nama_ac: data.nama_ac || '',
            merek_ac: data.merek_ac || '',
            serial_number: data.serial_number || '',
            ketinggian_ac: data.ketinggian_ac || '',
            kapasitas_pk: data.kapasitas_pk || '',
            message: '',
          });
          stopScanner();
        } else {
          setErrorMessage('Data tidak ditemukan.');
          stopScanner();
        }
      } catch (error) {
        console.error('QR code data is invalid:', error);
        setErrorMessage('Terjadi kesalahan saat mengambil data.');
        stopScanner();
      }
    } else {
      setErrorMessage(
        'QR Code tidak valid. Silahkan scan QR Code dari Jasa Indonesia Perdana'
      );
      stopScanner();
    }
  };

  const enableManualInput = () => {
    setIsManualInput(true);
    setFormData({
      id: null,
      nama_ac: '',
      merek_ac: '',
      serial_number: '',
      ketinggian_ac: '',
      kapasitas_pk: '',
      message: '',
    });
  };
  const dataToSubmit = {
    ...formData,
    id_pelanggan: userId, 
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); 
    try {
      const response = await submitRequestService(dataToSubmit);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Permintaan Anda telah terkirim!',
      }).then(() => {
        // Reset form fields after clicking OK
        setFormData({
          id: '',
          nama_ac: '',
          merek_ac: '',
          serial_number: '',
          ketinggian_ac: '',
          kapasitas_pk: '',
          message: '',
        });
      });;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Terjadi Kesalahan, silahkan coba lagi.',
      });
    }
  };

  return (
    <div className="request-service-form">
      {isScanning ? (
        <div>
          <video
            ref={(el) => setVideoElement(el)}
            style={{ width: '100%' }}
            id="video"
            autoPlay
            muted
          ></video>
          <button className="qr-scan-btn" onClick={stopScanner}>
            Stop Scanning
          </button>
        </div>
      ) : (
        <button className="qr-scan-btn" onClick={startScanner}>
          <img src={qrLogo} alt="QR Code" />
          <span>Scan QR AC JIP</span>
        </button>
      )}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {errorMessage && !isManualInput && (
        <button className="manual-input-btn" onClick={enableManualInput}>
          Input Manual
        </button>
      )}
      <p className="instruction">
        ISI SECARA MANUAL JIKA QR BERMASALAH ATAU UNTUK AC BARU
      </p>
      <p className="required_text">
        Tanda <span className="required">*</span> Wajib diisi
      </p>
      <form  onSubmit={handleSubmit}>
          
          <input
            type="hidden"
            value={formData.id}
            onChange={(e) => setFormData({ ...formData, id: e.target.value })}
            className="input-field"
            placeholder="Nama AC"
            disabled={!isManualInput}
            required
          />
        <label className="label">
          Nama AC <span className="required">*</span>
          <input
            type="text"
            value={formData.nama_ac}
            onChange={(e) =>
              setFormData({ ...formData, nama_ac: e.target.value })
            }
            className="input-field"
            placeholder="Nama AC"
            disabled={!isManualInput}
            required
          />
        </label>

        <label className="label">
          Merek AC <span className="required">*</span>
          <input
            type="text"
            value={formData.merek_ac}
            onChange={(e) =>
              setFormData({ ...formData, merek_ac: e.target.value })
            }
            className="input-field"
            placeholder="Merek AC"
            disabled={!isManualInput}
            required
          />
        </label>

        <label className="label">
          Serial Number
          <input
            type="text"
            value={formData.serial_number}
            onChange={(e) =>
              setFormData({ ...formData, serial_number: e.target.value })
            }
            className="input-field"
            placeholder="Serial Number"
            disabled={!isManualInput}
            required
          />
        </label>

        <label className="label">
          Ketinggian AC <span className="required">*</span>
          <input
            type="text"
            value={formData.ketinggian_ac}
            onChange={(e) =>
              setFormData({ ...formData, ketinggian_ac: e.target.value })
            }
            className="input-field"
            placeholder="Ketinggian AC"
            disabled={!isManualInput}
            required
          />
        </label>

        <label className="label">
          Kapasitas PK <span className="required">*</span>
          <input
            type="text"
            value={formData.kapasitas_pk}
            onChange={(e) =>
              setFormData({ ...formData, kapasitas_pk: e.target.value })
            }
            className="input-field"
            placeholder="Kapasitas PK"
            disabled={!isManualInput}
            required
          />
        </label>

        <label className="label">
          Keluhan / Permintaan Service <span className="required">*</span>
          <textarea
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            className="input-field message-field"
            placeholder="Contoh: Service Berkala"
            required
          />
        </label>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
}

export default RequestService;
